export default __webpack_public_path__ + "static/media/briefcase.823e442e.png";